import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import { smartActionTypes } from '../../../utils/app-configs';
import * as constants from '../constants';

export const priorities = handleActions(
  {
    [constants.GET_CATEGORY_INFO_SUCCESS]: (
      state,
      action,
    ) => action.payload.priorities,
    [combineActions(
      constants.GET_TICKET_SUCCESS,
      constants.CREATE_TICKET_SUCCESS,
    )]: (
      state,
      action,
    ) => action.payload.categoryInfo ? action.payload.categoryInfo.priorities : [],
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const followUpTypes = handleActions(
  {
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.customerDownTypes,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const actions = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.actions,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.actions,
    [constants.DELETE_SMART_ACTION_SUCCESS]: (
      state,
      action,
    ) => action.payload?.map(p => ({
      ...p.ticketAction,
      order: p.order,
    })),
    [constants.CREATE_SMART_ACTION_SUCCESS]: (
      state,
      action,
    ) => [
        {
          ...action.payload.ticketAction,
          order: action.payload.order,
          hasFollowupAction: action.payload.hasFollowupAction,
        },
        ...state,
      ],
    [constants.SAVE_SMART_ACTION_SUCCESS]: (
      state,
      action,
    ) => state?.map((a) => {
      if (a.id === action.payload.ticketAction.id) {
        return {
          order: action.payload.order,
          ...action.payload.ticketAction,
          hasFollowupAction: action.payload.hasFollowupAction,
        };
      }
      return a;
    }),
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const statuses = handleActions(
  {
    [combineActions(
      constants.CREATE_TICKET_SUCCESS,
      constants.GET_TICKET_SUCCESS,
      constants.SAVE_TICKET_SUCCESS,
    )]: (
      state,
      action,
    ) => action.payload.statuses,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const isNew = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: () => true,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.isNew,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
      constants.SAVE_TICKET_SUCCESS,
    )]: () => false,
  },
  false,
);

export const categories = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.categories,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.categories,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const context = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.context,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.context,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const ticket = handleActions(
  {
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket,
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket,
    [constants.SAVE_TICKET_SUCCESS]: (state, action) => action.payload.ticket,
    [constants.SNOOZE_TICKET_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSnoozedUntil: payload.snoozedUntil,
    }),
    [combineActions(
      constants.SAVE_SMART_ACTION_SUCCESS,
      constants.CREATE_SMART_ACTION_SUCCESS,
    )]: (
      state,
      { payload },
    ) => {
        if (payload.ticketAction?.actionType?.id === smartActionTypes.customerDown) {
          return {
            ...state,
            recepientId: payload.ticketAction?.followUpBy,
            recepientDisplayName: payload.ticketAction?.followUpByDisplayName,
            recepientEmail: payload.ticketAction?.followUpByMail,
            recipient: {
              id: payload.ticketAction?.followUpById,
              displayName: payload.ticketAction?.followUpByDisplayName,
              email: payload.ticketAction?.followUpByMail,
            },
          };
        }
        return state;
      },
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const tags = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.tags,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.tags,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const categoryInfo = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.categoryInfo,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.categoryInfo,
    [constants.GET_CATEGORY_INFO_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const closingReasons = handleActions(
  {
    [combineActions(
      constants.GET_TICKET_SUCCESS,
      constants.CREATE_TICKET_SUCCESS,
    )]: (
      state,
      action,
    ) => action.payload.closingReasons,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const proposedActions = handleActions(
  {
    [combineActions(
      constants.GET_TICKET_SUCCESS,
      constants.CREATE_TICKET_SUCCESS,
    )]: (
      state,
      action,
    ) => action.payload.proposedActions,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const actionTypes = handleActions(
  {
    [combineActions(constants.GET_TICKET_ACTION_TYPES_SUCCESS)]: (
      state,
      action,
    ) => action.payload,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
      constants.GET_TICKET_ACTION_TYPES,
      constants.GET_TICKET_ACTION_TYPES_FAILURE,
    )]: () => [],
  },
  [],
);

export const linkedEntities = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.linkedEntities,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.linkedEntities,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const addCommentSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.ADD_COMMENT,
      constants.ADD_COMMENT_FAILURE,
    )]: () => false,
    [constants.ADD_COMMENT_SUCCESS]: () => true,
  },
  false,
);

export const ticketWatchers = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket.watchers,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket.watchers,
    [constants.SAVE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket.watchers,
    [constants.GET_TICKET_STATUS_SUCCESS]: (
      state,
      action,
    ) => action.payload.watchers,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const linkedSourceObject = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.linkedSourceObject,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.linkedSourceObject,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const ticketStatusId = handleActions(
  {
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket.statusId,
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.ticket.statusId,
    [constants.SAVE_TICKET_SUCCESS]: (state, action) => action.payload.ticket.statusId,
    [constants.GET_TICKET_STATUS_SUCCESS]: (state, action) => action.payload.status.id,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => '',
  },
  '',
);

export const comments = handleActions(
  {
    [constants.CREATE_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.comments,
    [constants.GET_TICKET_SUCCESS]: (
      state,
      action,
    ) => action.payload.comments,
    [constants.ADD_COMMENT_SUCCESS]: (state, action) => action.payload,
    [constants.GET_COMMENTS_BY_TICKET_ID_SUCCESS]: (state, action) => action.payload,
    [combineActions(
      constants.GET_TICKET,
      constants.GET_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.CREATE_TICKET_FAILURE,
    )]: () => [],
  },
  [],
);

export const isLoading = handleActions(
  {
    [combineActions(
      constants.CREATE_TICKET_SUCCESS,
      constants.CREATE_TICKET_FAILURE,
      constants.GET_TICKET_SUCCESS,
      constants.GET_TICKET_FAILURE,
    )]: () => false,
    [combineActions(constants.CREATE_TICKET, constants.GET_TICKET)]: () => true,
  },
  false,
);

export const isCommentsLoading = handleActions(
  {
    [combineActions(constants.ADD_COMMENT_SUCCESS, constants.ADD_COMMENT_FAILURE)]: () => false,
    [constants.ADD_COMMENT]: () => true,
  },
  false,
);

export const isLoadingCategoryInfo = handleActions(
  {
    [combineActions(
      constants.GET_CATEGORY_INFO_SUCCESS,
      constants.GET_CATEGORY_INFO_FAILURE,
    )]: () => false,
    [constants.GET_CATEGORY_INFO]: () => true,
  },
  false,
);

export const isSaving = handleActions(
  {
    [combineActions(
      constants.GET_TICKET,
      constants.SAVE_TICKET_SUCCESS,
      constants.SAVE_TICKET_FAILURE,
    )]: () => false,
    [constants.SAVE_TICKET]: () => true,
  },
  false,
);

export const success = handleActions(
  {
    [combineActions(
      constants.GET_TICKET,
      constants.SAVE_TICKET,
      constants.SAVE_TICKET_FAILURE,
      constants.CREATE_TICKET,
      constants.RESET_TICKET_SUCCESS,
    )]: () => false,
    [constants.SAVE_TICKET_SUCCESS]: () => true,
  },
  false,
);

export const isSnoozing = handleActions(
  {
    [combineActions(
      constants.SNOOZE_TICKET_SUCCESS,
      constants.SNOOZE_TICKET_FAILURE,
    )]: () => false,
    [constants.SNOOZE_TICKET_REQUEST]: () => true,
  },
  false,
);

export const snoozeSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.SNOOZE_TICKET_REQUEST,
      constants.SNOOZE_TICKET_FAILURE,
    )]: () => false,
    [constants.SNOOZE_TICKET_SUCCESS]: () => true,
  },
  false,
);

export const snoozeFailure = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.SNOOZE_TICKET_REQUEST,
      constants.SNOOZE_TICKET_SUCCESS,
    )]: () => false,
    [constants.SNOOZE_TICKET_FAILURE]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.ADD_COMMENT_SUCCESS,
      constants.ADD_COMMENT,
      constants.CREATE_TICKET_SUCCESS,
      constants.CREATE_TICKET,
      constants.GET_TICKET_SUCCESS,
      constants.GET_TICKET,
      constants.SAVE_TICKET,
      constants.SAVE_TICKET_SUCCESS,
      constants.GET_CATEGORY_INFO,
      constants.GET_CATEGORY_INFO_SUCCESS,
      constants.GET_TICKET_ACTION_TYPES,
      constants.GET_TICKET_ACTION_TYPES_SUCCESS,
      constants.FETCH_SMART_ACTION,
      constants.FETCH_SMART_ACTION_SUCCESS,
      constants.SAVE_SMART_ACTION,
      constants.SAVE_SMART_ACTION_SUCCESS,
      constants.CREATE_SMART_ACTION,
      constants.CREATE_SMART_ACTION_SUCCESS,
      constants.SNOOZE_TICKET_REQUEST,
      constants.SNOOZE_TICKET_SUCCESS,
    )]: () => ({}),
    [combineActions(
      constants.CREATE_TICKET_FAILURE,
      constants.GET_TICKET_FAILURE,
      constants.ADD_COMMENT_FAILURE,
      constants.SAVE_TICKET_FAILURE,
      constants.GET_CATEGORY_INFO_FAILURE,
      constants.GET_TICKET_ACTION_TYPES_FAILURE,
      constants.FETCH_SMART_ACTION_FAILURE,
      constants.SAVE_SMART_ACTION_FAILURE,
      constants.CREATE_SMART_ACTION_FAILURE,
      constants.SNOOZE_TICKET_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  priorities,
  actions,
  statuses,
  categories,
  categoryInfo,
  closingReasons,
  ticket,
  tags,
  actionTypes,
  comments,
  context,
  isLoading,
  isCommentsLoading,
  isSaving,
  success,
  error,
  linkedEntities,
  linkedSourceObject,
  isLoadingCategoryInfo,
  isNew,
  ticketStatusId,
  ticketWatchers,
  addCommentSuccess,
  isSnoozing,
  snoozeSuccess,
  snoozeFailure,
  followUpTypes,
  proposedActions,
});
